(() => {
  function updateStaffel(fieldset) {
    if (!fieldset) return;
    const radios = Array.from(fieldset.querySelectorAll('.ji-staffel__radio'));
    const checked = radios.find((radio) => radio.checked);
    const index = Math.max(0, radios.indexOf(checked));

    fieldset.querySelectorAll('.ji-staffel__card').forEach((card) => card.classList.remove('is-selected'));
    if (checked) {
      const activeCard = fieldset.querySelector('label[for="' + checked.id + '"]');
      if (activeCard) activeCard.classList.add('is-selected');
    }

    fieldset.querySelectorAll('.ji-snocks-saving').forEach((el) => el.remove());
    fieldset.querySelectorAll('.ji-staffel__marker').forEach((marker) => {
      const tier = Number(marker.dataset.tier || 0) - 1;
      const def = marker.querySelector('.ji-staffel__marker-def');
      const sel = marker.querySelector('.ji-staffel__marker-sel');
      marker.style.display = 'none';
      if (def) def.style.display = 'none';
      if (sel) sel.style.display = 'none';
      if (tier === index && index > 0) {
        marker.style.display = 'block';
        if (sel) sel.style.display = 'inline';
      } else if (tier > index) {
        marker.style.display = 'block';
        if (def) def.style.display = 'inline';
      }
    });
  }
  function updateAll() { document.querySelectorAll('.ji-staffel').forEach(updateStaffel); }
  document.addEventListener('DOMContentLoaded', updateAll);
  document.addEventListener('change', (event) => { if (event.target && event.target.matches('.ji-staffel__radio')) updateStaffel(event.target.closest('.ji-staffel')); });
  document.addEventListener('click', (event) => { const card = event.target.closest('.ji-staffel__card'); if (card) setTimeout(() => updateStaffel(card.closest('.ji-staffel')), 30); });
  document.addEventListener('variant:change', () => setTimeout(updateAll, 40));
  setTimeout(updateAll, 80);
})();

(() => {
  const dayNames = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  const dayMs = 24 * 60 * 60 * 1000;
  let deliveryTimer = null;
  let observerStarted = false;

  function dateKey(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${month}-${day}`;
  }

  function formatDate(date) {
    return `${dayNames[date.getDay()]} ${date.getDate()}.${date.getMonth() + 1}.`;
  }

  function addDays(date, days) {
    const nextDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    nextDate.setDate(nextDate.getDate() + days);
    return nextDate;
  }

  function easterSunday(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month, day);
  }

  function holidayKeys(year) {
    const fixedHolidays = new Set([
      '01-01',
      '01-06',
      '03-08',
      '05-01',
      '08-15',
      '09-20',
      '10-03',
      '10-31',
      '11-01',
      '12-25',
      '12-26'
    ]);
    const easter = easterSunday(year);

    [
      addDays(easter, -2),
      addDays(easter, 1),
      addDays(easter, 39),
      addDays(easter, 50),
      addDays(easter, 60)
    ].forEach((holiday) => fixedHolidays.add(dateKey(holiday)));

    return fixedHolidays;
  }

  function isBusinessDay(date) {
    const day = date.getDay();
    if (day === 0 || day === 6) return false;
    return !holidayKeys(date.getFullYear()).has(dateKey(date));
  }

  function addBusinessDays(startDate, days) {
    let result = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    let remaining = days;

    while (remaining > 0) {
      result = addDays(result, 1);
      if (isBusinessDay(result)) remaining -= 1;
    }

    return result;
  }

  function deliveryRange() {
    const now = new Date();
    return `${formatDate(addBusinessDays(now, 1))} - ${formatDate(addBusinessDays(now, 3))}`;
  }

  function enhanceDeliveryRows() {
    const range = deliveryRange();

    document.querySelectorAll('.ji-cart-shipping-notice').forEach((row) => {
      const originalText = row.dataset.jiOriginalText || row.textContent || '';
      row.dataset.jiOriginalText = originalText;

      const priceLabel = /ab\s*20/i.test(originalText) ? 'ab 20€ kostenlos' : 'Kostenlos';
      const key = `${range}|${priceLabel}`;

      if (row.dataset.jiDeliveryEnhanced === key) return;

      row.dataset.jiDeliveryEnhanced = key;
      row.classList.add('ji-cart-delivery-row');
      row.innerHTML = `<span class="ji-cart-delivery-row__date">Lieferung ca. ${range}</span><span class="ji-cart-delivery-row__price">${priceLabel}</span>`;
    });
  }

  function scheduleEnhanceDeliveryRows() {
    window.clearTimeout(deliveryTimer);
    deliveryTimer = window.setTimeout(enhanceDeliveryRows, 40);
  }

  function startObserver() {
    if (observerStarted || !document.body) return;
    observerStarted = true;

    new MutationObserver(scheduleEnhanceDeliveryRows).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      enhanceDeliveryRows();
      startObserver();
    });
  } else {
    enhanceDeliveryRows();
    startObserver();
  }

  document.addEventListener('cart:refresh', scheduleEnhanceDeliveryRows);
  document.addEventListener('cart:change', scheduleEnhanceDeliveryRows);
})();
